import React, { useState, useEffect } from 'react';
import { cn } from '../lib/utils';
import Lenis from '@studio-freight/lenis';
import { ZoomParallax } from './ui/zoom-parallax';
import { productService } from '../services/api';

export default function ZoomParallaxDemo() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await productService.getCarousel();
        const carouselImages = (res.data.items || []).map((item) => ({
          src: item.image,
          alt: item.alt || 'Carousel image',
        }));
        setImages(carouselImages.length > 0 ? carouselImages : getFallbackImages());
      } catch (error) {
        console.error('Error fetching carousel images:', error);
        setImages(getFallbackImages());
      }
    };
    fetchImages();
  }, []);

  const getFallbackImages = () => [
    {
      src: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1280&h=720&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Modern architecture building',
    },
    {
      src: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1280&h=720&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Urban cityscape at sunset',
    },
    {
      src: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=800&h=800&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Abstract geometric pattern',
    },
    {
      src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1280&h=720&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Mountain landscape',
    },
    {
      src: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800&h=800&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Minimalist design elements',
    },
    {
      src: 'https://images.unsplash.com/photo-1439066615861-d1af74d74000?w=1280&h=720&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Ocean waves and beach',
    },
    {
      src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1280&h=720&fit=crop&crop=entropy&auto=format&q=80',
      alt: 'Forest trees and sunlight',
    },
  ];

  return (
    <main className="min-h-screen w-full">
      <div className="relative flex h-[30vh] md:h-[50vh] items-center justify-center">
        <div
          aria-hidden="true"
          className={cn(
            'pointer-events-none absolute -top-1/2 left-1/2 h-[120vmin] w-[120vmin] -translate-x-1/2 rounded-full',
            'bg-[radial-gradient(ellipse_at_center,--theme(--color-foreground/.1),transparent_50%)]',
            'blur-[30px]'
          )}
        />
        <h1 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gold-400 px-4 tracking-tight">
          The Lifestyle Gallery
        </h1>
      </div>
      <ZoomParallax images={images} />
      <div className="h-[30vh] md:h-[50vh]" />
    </main>
  );
}
